import Sidebar from "../layouts/sidebar";
import Header from "../layouts/header";
import Layout from "../layouts/layout";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import candidateActions from "../redux/candidate/actions";
import { useSelector } from "react-redux";
import TablePagination from '@mui/material/TablePagination';
import CandidateDumpTable from "../common/CandidateDumpTable";
import JSZip from 'jszip';
import { API_URL } from "../utils/constants";


const CandidateDump = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const dispatch = useDispatch()
    const { generatingRowIds, generatedRows, courseNameForDump, pendingDump } = useSelector((state) => state.candidateReducer);

    console.log(courseNameForDump,"courseNameForDump")

    const handleGenerateFunc = (row) => {
        dispatch({
            type: candidateActions.GENERATE_DUMP_REQUEST, payload: {
                rowId: row?.courseid
                // rowId: row.id
            }
        });
    }
    
    const handleRegenrateFunc = (row, isRegenerate) => {
        dispatch({
            type: candidateActions.GENERATE_DUMP_REQUEST, payload: {
                rowId: row?.courseid,
                isRegenerate:isRegenerate
            }
        });
    }

    let applicationStatusColumns = [
        {
            name: "Course Name",
            dataIndex: "coursename",
        },
        {
            name: "Total Candidates",
            dataIndex: "candidatecount",
        },
        {
            name: "Action",
            dataIndex: "action",
        },
    ];



    // const applicationStatusData = [
    //     {
    //         coursename: "Advanced Robotics Engineering",
    //         totalcandidates: 800076,
    //         action: "",
    //         id: 1
    //     },
    //     {
    //         coursename: "Digital Marketing Strategies",
    //         totalcandidates: 858000,
    //         action: "",
    //         id: 2
    //     },
    //     {
    //         coursename: "Data Science Fundamentals",
    //         totalcandidates: 900900,
    //         action: "",
    //         id: 3
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 4
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 5
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 6
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 7
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 8
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 9
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 10
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 11
    //     },
    //     {
    //         coursename: "Creative Writing Workshop",
    //         totalcandidates: 950578,
    //         action: "",
    //         id: 12
    //     },
    // ];


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDownloadDump = async (row, downloadUrl) => {
        if (!downloadUrl) return;
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `dump_${row?.courseid}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
};

      const data = courseNameForDump || [];
    const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



    // const paginatedData = applicationStatusData.slice(
    //     page * rowsPerPage,
    //     page * rowsPerPage + rowsPerPage
    // );




    useEffect(() => {
        dispatch({
            type: candidateActions?.GET_COURSE_NAME_FOR_DUMP,
            payload: {},
        });
    }, []);

    useEffect(() => {
        const maxPage = Math.floor(paginatedData.length / rowsPerPage);
        if (page > maxPage) {
            setPage(0);
        }
    }, [paginatedData, page, rowsPerPage]);

    return (
        <>
            <Sidebar />
            <Header />
            <Layout>
                <div style={{ width: "100%", backgroundColor: "#fff", padding: 10, minHeight: "100%" }}>
                    <div style={{ width: "100%", backgroundColor: "#e8e8e8", padding: 8 }}>
                        <p style={{ fontWeight: "500", color: "#212121", fontSize: 18, lineHeight: "100%", marginLeft: 5 }}>Candidate dump</p>
                    </div>

                    {/* Table below */}
                    <CandidateDumpTable
                        tableData={paginatedData}
                        columnData={applicationStatusColumns}
                        handleGenerateFunc={handleGenerateFunc}
                        generatingRowIds={generatingRowIds}
                        generatedRows={generatedRows}
                        pendingDump={pendingDump}
                        handleDownloadDump={handleDownloadDump}
                        handleRegenrateFunc={handleRegenrateFunc}
                    />
                </div>

                <div
                    style={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        padding: "8px 16px",
                    }}>
                    <TablePagination
                        component="div"
                        count={paginatedData.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10]}
                    />
                </div>
            </Layout>
        </>
    )
}

export default CandidateDump;